import React from 'react';
import {
    Modal,
} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CheckboxTermsAndAffidavit from './checkbox-terms-affidavit';

const { useState } = React;

const KWalletActivateModal = (props) => {
    const {
        isOpen,
        handleClose,
    } = props;

    const [accept, setAccept] = useState(false);

    const onClose = (result) => {
        setAccept(false);
        handleClose(result);
    };

    function handleOnChange(checked) {
        setAccept(checked);
    }

    return (
        <Modal show={isOpen} aria-labelledby="contained-modal-title-lg" id="modal-municipality-selector">
            <Modal.Header>
                <Modal.Title id="contained-modal-title-lg">
                    <FormattedMessage id="modal-kwallet-activate" defaultMessage="Activate Kwallet" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <FormattedMessage id="modal-kwallet-activate-text" defaultMessage="Al parecer aun no has activado tu K-Wallet." />
                    <br />
                    <CheckboxTermsAndAffidavit onChange={handleOnChange} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    disabled={!accept}
                    type="button"
                    style={{ marginRight: '5px' }}
                    className="button-secondary button-small"
                    onClick={() => onClose(true)}
                >
                    <FormattedMessage id="modal-kwallet-activate-activate" defaultMessage="Activate" />
                </button>
                <button
                    type="button"
                    style={{ marginRight: '5px' }}
                    className="button-secondary button-small"
                    onClick={() => onClose(false)}
                >
                    <FormattedMessage id="modal-kwallet-activate-cancel" defaultMessage="Maybe Later" />
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default KWalletActivateModal;



/** WEBPACK FOOTER **
 ** ./src/components/shared/kwallet-activation-modal.js
 **/